import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800 bg-white">
      <h1 className="text-3xl font-bold mb-4">Shipping and Delivery Policy</h1>
      <p className="mb-4">Last updated: July 14, 2025</p>

      <p className="mb-4">Since we offer <strong>digital products</strong>, there is no physical shipping involved.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Digital Delivery:</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Once payment is successful, the course download link (Google Drive or similar) will be sent to the buyer’s email within <strong>5–30 minutes</strong>.</li>
        <li>If you don't receive it, please check your spam/junk folder or contact us directly.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Errors in Email:</h2>
      <p className="mb-4">Ensure your email ID is correct at checkout. We are not responsible for delays due to incorrect information.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us:</h2>
      <p>Email: <a href="mailto:jivanpawar023@gmail.com" className="text-blue-500 underline">jivanpawar023@gmail.com</a></p>
    </div>
  );
};

export default ShippingPolicy;
